import React from 'react';
import { Container, Flex, Heading } from 'theme-ui';
import FlexImage from '@solid-ui-components/FlexImage';
import FlexContent from '@solid-ui-components/FlexContent';
import ContentText from '@solid-ui-components/ContentText';
import ContentButtons from '@solid-ui-components/ContentButtons';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import DottedNumberedList from '@solid-ui-components/DottedNumberedList/DottedNumberedList';

const styles = {
  heading: {
    fontSize: '36px',
    fontWeight: 600,
    lineHeight: '44px',
    color: '#101828',
    pb: '40px'
  }
}

const FeaturesWithPhotoBlock012 = ({ content: { text, collection, buttons }, reverse }) => (

  <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Heading as="div" sx={styles.heading}>How it works</Heading>
    <FlexContent sx={{ maxWidth: ['100%', '100%', '100%', '100%', '68%'] }} reverse={reverse}>
      <DottedNumberedList collection={collection} />
    </FlexContent>
  </Container>
);



export default WithDefaultContent(FeaturesWithPhotoBlock012);
